// utils/userService.js

import axios from '../axios';  // 引入全局配置的 axios 实例

// 定义获取用户昵称的函数
export async function getUsername() {
    try {
        const response = await axios.get('/user/user-data');  // 修改为正确的路径
        return response.data.playerName;  // 返回用户昵称
    } catch (error) {
        console.error('获取用户昵称时出错:', error);
        return null;  // 如果出错，返回 null
    }
}